import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";
import { Box } from "@chakra-ui/react";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";
import { AuthUser } from "../../../types/User/AuthUser";

export const dashboardSelectFilterData = (
  provinceOptions: Option[],
  countyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedProvince: Dispatch<SetStateAction<Option | null>>,
  setSelectedCounty: Dispatch<SetStateAction<Option | null>>,
  selectedProvince: Option | null,
  provinceLoaded: boolean,
  countyLoaded: boolean,
  user: AuthUser,
) => {
  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    const selected = countyOptions.find(
      (p) => p.id.toString() === selectedCountyId,
    );
    setSelectedCounty(selected || null);
    setFilter("CountyId", selectedCountyId);
  };

  return (
    <>
      <Box>
        <SelectComponent
          fieldNameObject="ProvinceId"
          options={provinceOptions}
          fieldName="Seleccionar Província"
          width="270px"
          control={control}
          onChange={handleProvinceChange}
          isLoaded={provinceLoaded}
          isRequired
          isDisabled={
            user?.role?.level !== undefined && user?.role.level.id >= 4
          }
          defaultValue={
            user?.role?.level !== undefined && user?.role.level.id >= 4
              ? user.province?.id
              : ""
          }
        />
      </Box>
      <Box>
        <SelectComponent
          fieldNameObject="CountyId"
          options={countyOptions}
          fieldName="Seleccionar Município"
          width="270px"
          control={control}
          onChange={handleCountyChange}
          placeholder="Todos os Municípios"
          isLoaded={countyLoaded}
          isDisabled={
            (user?.role?.level !== undefined && user?.role.level.id === 5) ||
            !selectedProvince ||
            selectedProvince.name === ""
          }
          defaultValue={
            user?.role?.level !== undefined && user?.role.level.id === 5
              ? user.county?.id
              : ""
          }
        />
      </Box>
    </>
  );
};
